import { withGlobalOptions } from '../../types'

export const orderHandles = withGlobalOptions({})
